// Lucide icon: funnel (https://lucide.dev/icons/funnel)
import { Funnel } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconFilter = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Funnel />
    </IconComponentStyled>
  )
}
